import { trigger, animate, style, transition, state } from '@angular/animations';

const SLIDER_ANIMATION = '400ms ease-in-out';

export const slideInOut = trigger('slideInOut', [
  state('void', style({ transform: 'translate(0, 100%)' })),
  state('enter', style({ transform: 'none' })),
  state('leave', style({ transform: 'translate(0, 100%)' })),
  transition('* => *', animate(SLIDER_ANIMATION)),
]);
